import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { HealtheraButton } from '../../../../healtheraComponents';
import { VirtualMedicine } from '../../../../apis/virtual-medicines/types';
import { enqueueSnackbar } from 'notistack';
import { useCreateVirtualMedicine } from '../../../../apis/virtual-medicines/hooks/useCreateVirtualMedicine';
import { useHistory } from 'react-router';

interface Props {
  form: UseFormReturn<VirtualMedicine>;
}

const CreateVirtualMedicine = ({ form }: Props) => {
  const history = useHistory();
  const { createVirtualMedicine, isLoading } = useCreateVirtualMedicine();

  const handleSave = async (virtualMedicine: VirtualMedicine) => {
    await createVirtualMedicine(virtualMedicine);

    informAboutSuccess();

    history.goBack();
  };

  const handleInvalidForm = () => {
    enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
  };

  return (
    <HealtheraButton disabled={isLoading} onClick={form.handleSubmit(handleSave, handleInvalidForm)}>
      Create
    </HealtheraButton>
  );
};

function informAboutSuccess() {
  enqueueSnackbar('Virtual medicine created', { variant: 'success' });
}

export default CreateVirtualMedicine;
